import { LinkPlainExternal } from 'app_previous/elements/links/Link.plain';
import styled from 'styled-components';

export const SlideContainer = styled(LinkPlainExternal)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 0 1rem;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
`;

export const SlideImageContainer = styled.section`
  margin-bottom: 1.5rem;
  aspect-ratio: 1 / 1;

  .gatsby-image-wrapper {
    object-fit: cover;
    width: 100%;
    height: 100%;

    img {
      border-radius: 11px;

      // Avoid image dragging when dragging slider
      -webkit-user-drag: none;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
`;

export const SlideTextBlock = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  > h1,
  > p {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
  }

  > h1 {
    margin-bottom: 1.5rem;
  }
`;
